const selectPriorities = (state) => state.priorities;
export default selectPriorities;
